// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AddToCartButton_wrapper__1gOdK","button":"AddToCartButton_button__1YPrW","pulse":"AddToCartButton_pulse__16f2I","input":"AddToCartButton_input__3DqQ3"};